import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Select } from '@/lib/v2/components';

import { useRuleDefaultOptions } from '@/modules/RulesModule/components/FormRule/hooks/useRuleDefaultOptions';
import {
  TRANSLATE_RULES_LABELS,
  TRANSLATE_RULES_PLACEHOLDERS,
} from '@/modules/RulesModule/constants';
import { IFormProps, IRuleForm } from '@/modules/RulesModule/interfaces';

interface ICustomFieldSelectProps {
  form: IFormProps<IRuleForm>;
  rules: Record<string, RegisterOptions>;
  disabled?: boolean;
}

export const CustomFieldSelect = ({ form, disabled = false, rules }: ICustomFieldSelectProps) => {
  const { t } = useTranslation('rules');
  const { customFieldOptions } = useRuleDefaultOptions();

  return (
    <div className="mb-5 mr-8 w-full" id="custom-field-select">
      <Select
        isRequired
        control={form.control}
        disabled={disabled}
        label={t(`${TRANSLATE_RULES_LABELS}.customFieldTrigger`)}
        name="customField"
        options={customFieldOptions}
        placeholder={t(`${TRANSLATE_RULES_PLACEHOLDERS}.customField`)}
        rules={rules.customField}
      />
    </div>
  );
};
